export default {
  user: 'ユーザーが',
  admin: 'アドミンが'
};
